import { render, staticRenderFns } from "./VariantFulfillmentColumn.vue?vue&type=template&id=2f57fd86&"
import script from "./VariantFulfillmentColumn.vue?vue&type=script&lang=js&"
export * from "./VariantFulfillmentColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports